import {React,  useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { CreateContainer, Header, MainContainer, Order } from './components'
import {AnimatePresence} from 'framer-motion'
import { useStateValue } from './context/StateProvider'
import { getAllFoodItems, getUserOrders } from './utils/firebaseFunctions'
import { actionType } from './context/reducer'
import Profile from './components/Profile'

const App = () => {
  const [{foodItems,orders}, dispatch] = useStateValue();

  const fetchData = async () =>{
    await getAllFoodItems().then((data) =>{
      dispatch({
        type: actionType.SET_FOOD_ITEMS,
        foodItems: data
      })
    })
    
  }
  const fetchOrder = async ()=>{
    await getUserOrders().then((data)=>{
      dispatch({
        type: actionType.SET_ORDER,
        orders:data
      })
    })
    
  }

  useEffect(()=>{
    fetchData();
    fetchOrder();
  },[])


  return (
    <AnimatePresence exitBeforeEnter>
          <div className='w-screen h-auto flex flex-col bg-primary'>
            <Header/>
            <main className='mt-14 md:mt-20 px-4 md:px-16 py-4 w-full'>
              <Routes>
                <Route path='/*' element={<MainContainer />}  />
                <Route path='/createItem' element={<CreateContainer />}/>
                <Route path='/profile' element={<Profile />}/>
                <Route path='/orders' element={<Order />}/>
              </Routes>
            </main>
          </div>
    </AnimatePresence>

  )
}

export default App